import { render, staticRenderFns } from "./FooterTemplate.vue?vue&type=template&id=59f60121&scoped=true"
import script from "./FooterTemplate.vue?vue&type=script&lang=js"
export * from "./FooterTemplate.vue?vue&type=script&lang=js"
import style0 from "./FooterTemplate.vue?vue&type=style&index=0&id=59f60121&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f60121",
  null
  
)

export default component.exports